module.exports = __webpack_public_path__ + "img/renault.4eed5ca2.png";